import { combineReducers } from "redux";
import {
    persistReducer
    // FLUSH,
    // REHYDRATE,
    // PAUSE,
    // PERSIST,
    // PURGE,
    // REGISTER
} from "redux-persist";
import hardSet from "redux-persist/lib/stateReconciler/hardSet";
import storage from "redux-persist/lib/storage";
import ACTIVE_SERVER from "../../services/config";
import { APP_VERSION } from "../../siteDefaults/config";
import { changeCurrencyIdReducer, changeSideReducer, currenciesReducer } from "./curreniesReducer";
import { spinnerReducer, transactionsLoadingReducer } from "./loadingReducer";
import { toggleModeReducer } from "./toggleModeReducer";
import { userInfo } from "./user";

const persistedReducer = persistReducer(
    {
        key: `${ACTIVE_SERVER.serverName}__rashtrade-v-${APP_VERSION}`,
        storage,
        timeout: 5000,
        version: 8,
        stateReconciler: hardSet
    },
    combineReducers({
        userInfo,
        currenciesList: currenciesReducer,
        currentCurrencyId: changeCurrencyIdReducer,
        currentSide: changeSideReducer,
        spinnerStatus: spinnerReducer,
        transSpinnerStatus: transactionsLoadingReducer,
        isDarkMode: toggleModeReducer
    })
);

// export const store = createStore(reducers,
//     compose(applyMiddleware(thunk))
// )

export const reducers = combineReducers({
    persistedReducer
});
